import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import { FORMATS_KEYS, REFRESH_AD_COOLDOWN_SECONDS } from "shared/modules/onpageads/constants";

class DisplayAdOnPage extends React.Component {
	static propTypes = {
		format: PropTypes.oneOf(Object.values(FORMATS_KEYS)).isRequired,
		refresh: PropTypes.bool,
	};

	static defaultProps = {
		refresh: false,
	};

	constructor(props) {
		super(props);
		const rand = Math.floor(Math.random() * 10000 * 10000);

		this.state = {
			id: `div-gpt-ad-DISPLAYADS-REACT-${props.format}-${rand}`,
		};
	}

	componentDidMount() {
		const { id } = this.state;
		const { format } = this.props;

		if (typeof (window.OnPageAds) !== "undefined") {
			// wait a hot sec so onpageads can be loaded first
			setTimeout(() => {
				window.OnPageAds.addAd({ id, format });

				if (this.props.refresh) {
					this.refreshId = setInterval(() => {
						window.OnPageAds.refreshAdsById(id);
					}, REFRESH_AD_COOLDOWN_SECONDS * 1000);
				}
			}, 10);
		}
	}

	shouldComponentUpdate() {
		// once this renders, it should stay that way. so go ahead and GFY
		return false;
	}

	componentWillUnmount() {
		if (typeof (window.OnPageAds) !== "undefined") {
			window.OnPageAds.removeAd(this.state.id);
		}

		clearInterval(this.refreshId);
	}

	render() {
		const id = this.state.id;
		const classes = classnames({
			"ad": true,
			"format": true,
			[`format--${this.props.format}`]: true,
		});

		return <div id={id} className={classes} />;
	}
}

export default DisplayAdOnPage;



// WEBPACK FOOTER //
// ./src/shared/components/DisplayAdOnPage.jsx